var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LifeDetailed"},[_c('div',{staticClass:"LifeDetailed__content container-inner"},[(this.$store.state.step == 1)?_c('slider-question',_vm._b({key:1},'slider-question',{
            title: 'Outstanding debt',
            description: 'What is the total amount of your outstanding debt? <br>(e.g. mortgages, personal loans, credit card etc.)',
            min: 0,
            type: 'money',
            format: 'thousands',
            max: 200000,
            tick: 50000,
            step: 10000,
            value: this.$store.state.debts,
            customVal: this.$store.state.customDebts,
            name: 'debts',
            customName: 'customDebts',
            previous: 1,
            next: 2
        },false)):_vm._e(),(this.$store.state.step == 2)?_c('slider-question',_vm._b({key:2},'slider-question',{
            title: 'Your Expenses',
            description: 'What is your estimated weekly household spending beside debt repayments? <br>(e.g. groceries, utilities, school fees, etc.)',
            min: 0,
            type: 'money',
            max: 5000,
            tick: 1000,
            step: 250,
            value: this.$store.state.expenses,
            customVal: this.$store.state.customExpenses,
            name: 'expenses',
            customName: 'customExpenses',
            previous: 1,
            next: 3
        },false)):_vm._e(),(this.$store.state.step == 3)?_c('slider-question',_vm._b({key:3},'slider-question',{
            title: 'Other Income',
            description: 'What is your annual after-tax income from sources other than your salary and wages? (e.g.partner\'s income, investments, government support etc.)',
            min: 0,
            type: 'money',
            format: 'thousands',
            max: 20000,
            tick: 5000,
            step: 1000,
            value: this.$store.state.incomeOther,
            customVal: this.$store.state.customIncomeOther,
            name: 'incomeOther',
            customName: 'customIncomeOther',
            previous: 2,
            next: 4
        },false)):_vm._e(),(this.$store.state.step == 4)?_c('button-question',_vm._b({key:4},'button-question',{
            title: 'Children',
            description: 'Your children should be given the best start in life with a quality education, even if you’re no longer around. Do you have any school-aged children (under 18)?',
            previous: 3,
            responses: {
                1: {
                    title: 'No',
                    id: false,
                    icon: _vm.person,
                    next: 'results'
                },
                2: {
                    title: 'Yes',
                    id: true,
                    icon: _vm.personWithChild,
                    next: 5
                }
            },
            value: this.$store.state.children,
            name: 'children'
        },false)):_vm._e(),(this.$store.state.step == 5)?_c('button-question',_vm._b({key:5},'button-question',{
            title: 'School',
            description: 'Do your children go to private or government school?',
            previous: 4,
            responses: {
                1: {
                    title: 'Private',
                    id: 'private',
                    icon: _vm.school,
                    next: 6
                },
                2: {
                    title: 'Government',
                    id: 'government',
                    icon: _vm.school,
                    next: 6
                }
            },
            value: this.$store.state.school,
            name: 'school'
        },false)):_vm._e(),(this.$store.state.step == 6)?_c('slider-question',_vm._b({key:6},'slider-question',{
            title: 'Children',
            description: 'How many children do you have?',
            min: 1,
            type: 'number',
            max: 5,
            tick: 1,
            step: 1,
            value: this.$store.state.childrenNumber,
            customVal: this.$store.state.customChildrenNumber,
            name: 'childrenNumber',
            customName: 'customChildrenNumber',
            previous: 5,
            next: 7
        },false)):_vm._e(),(this.$store.state.step == 7)?_c('multi-slider-question',_vm._b({key:7},'multi-slider-question',{
            title: 'Children',
            description: 'How old ' + (this.$store.state.childrenNumber > 1 ? 'are your children?' : 'is your child?'),
            min: 1,
            type: 'number',
            max: 17,
            tick: 3,
            start: 9,
            step: 1,
            length: (this.$store.state.childrenNumber ? this.$store.state.childrenNumber : this.$store.state.customChildrenNumber),
            value: this.$store.state.childrenAge,
            measure: 'Child',
            name: 'childrenAge',
            previous: 6,
            next: 'results'
        },false)):_vm._e()],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }